/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {IFadeTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {gsap} from "gsap";
import {RoadKillGameMode} from "../server/RoadKillGameMode";


export class RoadKillSound {

    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];
    public static readonly MAIN_GAME_MUSIC: string = "background-music-main";

    //win sounds
    public static WIN_SYM_HIGHLLIGHT: string[] = ["winBlink1", "winBlink2", "winBlink3", "winBlink4"];
    public static WIN_TINY_SMALL: string = "winTinySmallEnd";
    public static WIN_MEDIUM: string = "winMediumEnd";
    public static WIN_MEDIUM_COUNT_UP: string = "winMediumCountUp";
    public static WIN_LARGE: string = "winLargeEnd";
    public static WIN_LARGE_COUNT_UP: string = "winLargeCountUp";
    public static WIN_BLINK: string = "winHighlight";
    public static BIG_WIN_LEVEL: string[] = ["bigWinLevel1", "bigWinLevel2", "bigWinLevel3", "bigWinLevel4", "bigWinLevel5"];
    public static BIG_WIN_END: string = "bigWinEnd";
    public static BIG_WIN_LEVEL_CHANGE: string = "bigWinLevelChange";
    public static PRE_BIG_WIN_WIN_GROUP: string = "preBigWin";
    public static WIN_CAP_START_ONE_SHOT: string = "winCapStartOneShot";
    public static WIN_CAP_COUNT_UP: string = "winCapCountUp";
    public static WIN_CAP_LOOP: string = "winCapLoop";
    public static WIN_CAP_END: string = "winCapEnd";
    public static AS_WIN: string = "asWin";
    public static AS_WIN_BIG: string = "asWinBig";


    public static WILD_MOVE: string = "jumpingWildMovement";
    public static WILD_CIRCLE: string = "wildCircle";
    public static CAR_MOVE: string = "carPassing";
    public static CAR_CRASH: string = "carCrashing";
    public static CAR_CRASHING_DRIVE_AWAY: string = "carCrashingDrivesAway";

    public static HEART_ADD: string = "heartAdd";
    public static HEART_REMOVED: string = "heartRemove";

    //FS SFS
    public static MAIN_TO_SFS_TRASITION: string = "transitionMainToFS";
    public static SFS_TO_MAIN_TRASITION: string = "transitionFsToMain";
    public static FS_SFS_CONTINUE_BUTTON: string = "continueButtonStartFS";
    public static FS_INTRO_LOOP_START: string = "fsIntroLoopStart";
    public static FS_INTRO_LOOP: string = "fsIntroLoop";
    public static SFS_INTRO_LOOP: string = "sfsIntroLoop";
    public static FS_BG_MUSIC: string = "background-music-freespin";
    public static SFS_BG_MUSIC: string = "background-music-superfreespin";
    public static FS_OUTRO_END: string = "fsEnd";
    public static SFS_OUTRO_END: string = "sfsEnd";
    public static PERSISTENT_MULTIPLIER: string = "multiplierCounterUpdate";
    public static FS_SFS_END_LOOP: string = "fsSfsEndLoop";
    public static TINKER: string = "tinker";
    public static TINKER_HIT: string = "tinkerHit";
    public static SPLIT_SYM: string = "split";
    public static SCATTER_LAND: string = "scatterLand";
    public static SCATTER_TRIGGER: string = "scatterBlam";
    public static ADD_HIT_LINE_SOUND: string = "hitAddLine";
    public static BEAR_SHAKE: string = "hitBear";
    public static DEER_SHAKE: string = "hitDear";
    public static RABBIT_SHAKE: string = "hitBunny";
    public static MULTIPLIER_MOVE_SOUND: string = "multiplierMoveToCounter";
    public static PLANK_SOUND: string = "setUpPlankAdd";
    public static PLANK_SOUND_2: string = "setUpPlankAdd2";
    public static RABBIT_EXPLOSION: string = "carAnimalExploding";
    public static SET_UP_POSTER_ADDED: string = "setUpPosterAdd";
    public static HILLY_BILLY_POP_UP: string = "hillyBillyPopUp";
    public static HILLI_BILLY_REMOVE_TYRE: string = "hillyBillyRemoveTire"
    public static HEART_GOLDEN_TO_RED: string = "heartBlueToRed";
    public static SPLIT_SWOOSH: string = "splitSwoosh";
    public static ROADBLOCK: string = "roadBlock";
    public static ROADBLOCK_DISAPPEAR: string = "roadBlockDisappear";
    public static TOTAL_ANIMAL_HIT: string = "totalAnimalHit";


    //mini FS
    public static RESPIN_BG_MUSIC: string = "background-music-minifreespin";
    public static RESPIN_END: string = "miniFreeSpinsEnd";
    public static RESPIN_START: string = "callToArmsIntro";
    public static RESPIN_ONE_SHOT: string = "miniFreeSpinStartOneShot";


    private _currentMusic: string;

    private player: NolimitAudioPlayer;

    constructor() {
        this.player = <NolimitAudioPlayer>SlotGame.sound
    }

    get audioPlayer(): NolimitAudioPlayer {
        return this.player
    }

    private static createConfig(name: string, volume?: number, repeat?: number) {
        return {
            name: name,
            volume: volume,
            repeat: repeat
        }
    }

    public playTrack(name: string, volume?: number, repeat?: number): NolimitHowl | undefined {
        Logger.logDev("sound PlayTrack: ", name, " vol: ", volume, " repeat: ", repeat);
        return this.player.playTrack(RoadKillSound.createConfig(name, volume, repeat));
    }

    public stopTrack(name: string): NolimitHowl | undefined {
        Logger.logDev("sound stopTrack: ", name);
        return this.player.stopTrack(name);
    }

    public fadeMusic(vol: number, duration: number): void {
        Logger.logDev("sound fade Music: ", this._currentMusic, " vol: ", vol);
        this.player.fadeTrack({name: this._currentMusic, duration: duration, to: vol});
    }

    public fadeTrack(namee: string, durr: number, vol: number): void {
        Logger.logDev("sound fade Track: ", namee, " vol: ", vol);
        this.player.fadeTrack({name: namee, duration: durr, to: vol});
    }

    public switchMusic(mode: GameMode | string, fadeOutConf?: IFadeTrackConf, fadeInConf?: IFadeTrackConf) {
        let nextMusic = "";
        Logger.logDev("sound switch to: ", mode);

        switch (mode) {
            case GameMode.FREESPIN:
                nextMusic = RoadKillSound.FS_BG_MUSIC;
                break;
            case RoadKillGameMode.SUPER_FREESPIN:
                nextMusic = RoadKillSound.SFS_BG_MUSIC;
                break;
            case RoadKillGameMode.RESPIN:
                nextMusic = RoadKillSound.RESPIN_BG_MUSIC;
                break;
            default:
                nextMusic = RoadKillSound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }
        if (this._currentMusic !== null) {
            const fadeName: string = this._currentMusic;
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade: NolimitHowl | undefined = this.player.fadeTrack(fadeOutConf);
                if (fade) {
                    gsap.to(this, {
                        duration: fadeOutConf.duration / 1000, onComplete: () => {
                            this.player.stopTrack(fadeName);
                        }
                    });
                } else {
                    this.player.stopTrack(fadeName);
                }
            } else {
                this.player.stopTrack(fadeName);
            }
        }

        Logger.logDev("Switch music from: " + this._currentMusic + " to: " + nextMusic);

        this.player.playTrack({name: nextMusic});
        if (fadeInConf) {
            fadeInConf.name = nextMusic;
            this.player.fadeTrack(fadeInConf);
        }
        this._currentMusic = nextMusic;
    }
}